module.exports = __webpack_public_path__ + "img/goods5.e6a09bf9.jpg";